import React from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import Box from '../Box';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';

import { colors } from '@styles/theme';

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

const Wrapper = styled(Box)`
  .react-datepicker-wrapper{
    width: 100%;

    .react-datepicker__input-container {
      input {
        display: block;
        width: 100%;
        margin: 0;
        outline: 0;
        border: 0;
        box-shadow: ${props =>
          props.error
            ? 'inset 0px 3px 5px 0px rgba(219, 47, 35, 0.1), inset 0px 0px 1px 1px rgba(219, 47, 35, 0.25)'
            : 'inset 0px 3px 5px 0px rgba(0, 0, 0, 0.1), inset 0px 0px 1px 1px rgba(0, 0, 0, 0.15)'};

        &:focus {
          box-shadow: ${props =>
            props.error
              ? 'inset 0px 3px 5px 0px rgba(219, 47, 35, 0.1), inset 0px 0px 0px 2px rgba(219, 47, 35, 0.25)'
              : 'inset 0px 3px 5px 0px rgba(16, 107, 87, 0.1), inset 0px 0px 0px 2px rgba(16, 107, 87, 0.25)'}
          border-radius: 4px;
        }

        font-size: 17px;
        margin-bottom: 16px;
        color: ${colors.primary}
        padding: 16px;
        border-raius: 4px;
      }
    }
  }
  
`;

// Todo: error status
function InputDatePicker(props) {
  const { error, ...otherProps } = props;
  return (
    <Wrapper error={error}>
      <DatePicker {...otherProps} />
    </Wrapper>
  );
}

export default InputDatePicker;
